import { render, staticRenderFns } from "./OfflineIcon.vue?vue&type=template&id=20c1228a&"
import script from "./OfflineIcon.vue?vue&type=script&lang=js&"
export * from "./OfflineIcon.vue?vue&type=script&lang=js&"
import style0 from "./OfflineIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports